// src/components/Home.js

import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const calculators = [
  {
    id: 'RS',
    title: 'REPUBLIKA SRPSKA',
    description: 'Obračuni plata sa uvećanjima i odbicima, doprinosi, topli obrok, privremeni i povremeni poslovi, autorski ugovor, ugovor o djelu, menadžerski ugovor, dohodak, gazdinstvo, samostalno zanimanje, vlasnik - osnovno zanimanje i zakup.',
  },
  { id: 'kalkulator-FBIH',
    title: 'FEDERACIJA BIH',
    description: 'Obračuni plate i doprinosa za puno radno vrijeme u FBIH, sa toplim obrokom, uvećanjima i odbicima.',
  },
];

const universalCalculators = [
  {
    id: 'datum-staza',
    title: 'RADNI STAŽ',
    description: 'Obračun radnog staža i pronalazak tačnog datuma za punu godinu radnog staža.',
  },
  { id: 'PDV',
    title: 'PDV ',
    description: 'Obračun PDV-a (bruto/neto) sa različitim stopama.',
  },
  { id: 'kamata',
    title: 'PORESKA KAMATA',
    description: 'Obračun poreske kamate na osnovicu za kašnjenje plaćanja.',
  },
  // po potrebi dodajte još univerzalnih kalkulatora
];

export default function Home() {
  return (
    <div className="home-wrapper">
      <h1 className="home-title">IZABERITE ENTITET ZA OBRAČUN</h1>
      <div className="cards-grid">
        {calculators.map((calc) => (
          <Link
            key={calc.id}
            to={`/${calc.id}`}
            className="card-link"
          >
            <div className="card">
              <h2 className="card-heading">{calc.title}</h2>
              <p className="card-desc">{calc.description}</p>
            </div>
          </Link>
        ))}
      </div>

      
      <h1 className="home-title" style={{ marginTop: '3rem' }}>
        UNIVERZALNI OBRAČUNI
      </h1>
      <div className="cards-grid">
        {universalCalculators.map(calc => (
          <Link key={calc.id} to={`/${calc.id}`} className="card-link">
            <div className="card">
              <h2 className="card-heading">{calc.title}</h2>
              <p className="card-desc">{calc.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
